import { SAndPRating } from '../../filter/types'

export interface UpdateTickerRating {
  ticker: string
  sAndPRating: SAndPRating
}

export const openTickerRating = () => ({ type: 'tickerRating.open' } as const)
export type OpenTickerRatingAction = ReturnType<typeof openTickerRating>

export const closeTickerRating = () => ({ type: 'tickerRating.close' } as const)
export type CloseTickerRatingAction = ReturnType<typeof closeTickerRating>

export const saveTickerRating = (dto: UpdateTickerRating) =>
  ({ type: 'tickerRating.save', payload: dto } as const)
export type SaveTickerRatingAction = ReturnType<typeof saveTickerRating>

// Carries the epic's branch outcome → reducer slots it into apiCall.status/error
export const setTickerRatingResult = (status: string, error: boolean) =>
  ({ type: 'tickerRating.result', payload: { status, error } } as const)
export type SetTickerRatingResultAction = ReturnType<
  typeof setTickerRatingResult
>

export type TickerRatingAction =
  | OpenTickerRatingAction
  | CloseTickerRatingAction
  | SaveTickerRatingAction
  | SetTickerRatingResultAction
